/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";
import checkout from "layouts/pages/users/new-user/schemas/form";

const {
  formField: {
    email,
    status,
    jabatan,
    bidang,
    pangkat,
    instansi,
    perusahaan,
    nama_user,
  },
} = checkout;

const validations = [
  Yup.object().shape({
    [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  }),
  Yup.object().shape({
    [status.name]: Yup.string().required(status.errorMsg),
    [instansi.name]: Yup.string().required(instansi.errorMsg),
    [perusahaan.name]: Yup.string().required(perusahaan.errorMsg),
    [nama_user.name]: Yup.string().required(nama_user.errorMsg),
  }),
];

export default validations;
